export const languageUtils = {
    language: "en-GB",
    currency: "USD",
    dateFormat: "DD/MM/YYYY",
};